<template>
  <div class="editor">
    <v-card-title class="px-0 pt-0">Description</v-card-title>
    <editor
      id="tinymce-editor"
      api-key="qagffr3pkuv17a8on1afax661irst1hbr4e6tbv888sz91jc"
      v-model="content"
      :init="{
        height: 500,
        menubar: false,
        plugins: [
          'advlist anchor autolink autosave code codesample directionality fullscreen hr image imagetools insertdatetime link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textpattern visualblocks visualchars wordcount',
        ],
        toolbar: [
          'searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent blockquote undo redo removeformat subscript superscript code codesample',
          'hr bullist numlist link image charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen',
        ],
      }"
      @input="updateContent"
    ></editor>
  </div>
</template>

<script>
import Editor from "vue-tinymce-editor";

export default {
  components: {
    editor: Editor,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      content: this.value,
    };
  },
  watch: {
    value(newValue) {
      if (newValue !== this.content) {
        this.content = newValue;
      }
    },
  },
  methods: {
    updateContent(newContent) {
      this.content = newContent;
      this.$emit("input", newContent);
    },
  },
};
</script>
